export const
    REPORTSUBJECT_RESET = 'reportsubject_reset',
    REPORTSUBJECTS_RESET = 'reportsubjects_reset',
    REPORTSUBJECTS_PENDING = 'reportsubjects_pending',
    REPORTSUBJECT_FOCUS = 'reportsubject_focus',
    REPORTSUBJECT_DELETED = 'reportsubject_deleted',
    REPORTSUBJECT_POSTING = 'reportsubject_posting',
    REPORTSUBJECT_EDITING = 'reportsubject_editing',
    REPORTSUBJECT_DELETING = 'reportsubject_deleting',
    REPORTSUBJECT_FAILED = 'reportsubject_failed',
    REPORTSUBJECTS_FAILED = 'reportsubjects_failed',
    REPORTSUBJECT_DOWNLOADED = 'reportsubject_downloaded',
    REPORTSUBJECTS_DOWNLOADED = 'reportsubjects_downloaded',
    REPORTSUBJECT_PICTURE_UPLOADING = 'reportsubject_picture_uploading',
    REPORTSUBJECT_PICTURE_FAILED = 'reportsubject_picture_failed',
    REPORTSUBJECT_PICTURE_UPLOADED = 'reportsubject_picture_uploaded',
    REPORTSUBJECT_PICTURE_DELETING = 'reportsubject_picture_deleting';



// WEBPACK FOOTER //
// src/store/reportsubjects/types.js